<script setup lang="ts">
import { Slot } from "@soft-db/ui";

defineOptions({ inheritAttrs: false });

defineProps<{
	/**
	 * The position of the reference element in the dom.
	 */
	position: "before" | "after";
}>();

const scrollWatcher = useTemplateRef("$scrollWatcher");

const sticking = ref(false);

useIntersectionObserver(scrollWatcher, (entries) => {
	if (entries.length === 0) {
		return;
	}

	sticking.value = !entries.at(0)!.isIntersecting;
});
</script>

<template>
	<div v-if="position === 'before'" ref="$scrollWatcher" data-scroll-watcher />
	<Slot v-bind="$attrs">
		<slot :sticking="sticking" />
	</Slot>
	<div v-if="position === 'after'" ref="$scrollWatcher" data-scroll-watcher />
</template>
